/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-14 13:49:00
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-28 17:31:59
 */
import { Form, Row, Col, Input, Select, Button, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { FieldData } from '../../models/fielddata'
import { SearchOutlined } from '@ant-design/icons'
import { StockfloorParams } from '../../services/stockfloor'
import { useDispatch, useSelector } from 'react-redux'
import {
  getCommonCodeCompletions,
  selectCommonCodes,
} from '../completion/completionSlice'
import { CommonCodeCategory } from '../../models/commoncode'
import {
  BillingCategories,
  BillingCategoryName,
} from '../../models/billingCategory'
import { pageStockfloorEdit } from './stockfloorModalSlice'
const { Option } = Select

export const StockfloorModalQuery = (props: {
  onValueChange: (queries: StockfloorParams) => void
  onclick: () => void
}) => {
  const [form] = Form.useForm()

  const [fields, setFields] = useState<FieldData[]>()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Durg, ''))
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      flag: 0,
    })
  }, [])

  const YPdata = useSelector(selectCommonCodes(CommonCodeCategory.Durg))

  return (
    <Form
      fields={fields}
      form={form}
      name='control-hooks'
      onFieldsChange={(_, fs) => {
        props.onValueChange(form.getFieldsValue())
        setFields(fs)
      }}
      // onFinish={(fs) => {
      //   dispatch(pageStockfloorEdit({ ...fs }));
      // }}
    >
      <Row
        style={{
          margin: '0 0 10px 0',
        }}
        justify='space-between'
      >
        <Space wrap={false}>
          <Form.Item name='Keyword' noStyle>
            <Input
              size='middle'
              placeholder='请输入关键字'
              allowClear
              prefix={<SearchOutlined />}
              style={{ width: '12rem' }}
            />
          </Form.Item>
          <Form.Item name='drugCategory' noStyle>
            <Select
              showSearch
              placeholder='药品分类'
              optionFilterProp='children'
              allowClear
              style={{ width: '8rem' }}
            >
              {YPdata.map((v: any) => {
                return (
                  <Option value={v.name} key={v.name}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='billingCategory' noStyle>
            <Select placeholder='开票项目' allowClear style={{ width: '8rem' }}>
              {BillingCategories.map((v) => {
                return (
                  <Option value={v} key={v}>
                    {BillingCategoryName(v)}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='flag' noStyle>
            <Select
              placeholder='是否库存目录'
              allowClear
              style={{ width: '8rem' }}
            >
              <Option value={0}>是否库存目录-否</Option>
              <Option value={1}>是否库存目录-是</Option>
            </Select>
          </Form.Item>
          <Button htmlType='submit' type='primary'>
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            style={{ float: 'right' }}
            onClick={() => {
              props.onclick()
            }}
          >
            批量修改
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
